import typeOf          from './typeOf'

function ucFirst( string ) {
  if ( typeOf( string ) === 'string' ) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  return string
}

export default ucFirst



// WEBPACK FOOTER //
// ../app/lib/utils/ucFirst.js